import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { Endpoints } from "../../Global/Endpoints";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import ChatBotWindow from "../ChatBot/ChatBotWindow";
import { useChat } from '../Layout/ChatContext';

const Benefits_PHIForm = () => {
  const contract = useSelector((state) => state.userData);
  const token = localStorage.getItem("AccessToken") || "YOUR_ACCESS_TOKEN_HERE";
  const [phiDetails, setPhiDetails] = useState(null);
  const [error, setError] = useState(null);
  const [toggleStates, setToggleStates] = useState({});
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [readAndUnderstand, setReadAndUnderstand] = useState(false);
  const {isChatVisible, toggleChat, showChat } = useChat();

  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";

    const [loading, setLoading] = useState(false);
  

   // State for validation messages
   const [validationMessages, setValidationMessages] = useState({
    PName: '',
    PAddress: ''
  });

  useEffect(() => {
    const fetchPHIFormDetails = async () => {
      try {
        const payload = {
          _Params: JSON.stringify({ EmailID: contract.userData.EmailID,DeviceType:isHighmarkPortal ? "HighmarkPortal" : "PatientPortal" }),
        };
        const response = await axios.post(Endpoints.LoadPHIForm, payload, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.data) {
          setPhiDetails(response.data);
          initializeToggleStates(response.data);
        } else {
          setError(t("failedloadphidetails"));
        }
      } catch (error) {
        setError(t("errorloadingphidetails"));
      }
    };
    fetchPHIFormDetails();
  }, [contract, token, t]);

  const initializeToggleStates = (data) => {
    setToggleStates({
      Benefits: data.Benefits === "T",
      Claims: data.Claims === "T",
      CaseManagement: data.CaseManagement === "T",
      Other: !!data.Other,
      HIVTest: data.HIVTest === "T",
      Drug: data.Drug === "T",
      Mentalillness: data.Mentalillness === "T",
      Genetic: data.Genetic === "T",
    });
  };
  const handleToggleChange = (field) => {
    setToggleStates((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  const handleInputChange = (field, value) => {
    setPhiDetails((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  };

  const handleReadAndUnderstandToggle = () => {
    setReadAndUnderstand(!readAndUnderstand);
  };

  const handleSubmit = async () => {

    
     // Reset validation messages
    let isValid = true;
    let newValidationMessages = { PName: '', PAddress: '' };

    // Check if PName and PAddress are filled
    if (!phiDetails.PName) {
      newValidationMessages.PName = t('namerequired'); 
      isValid = false;
    }
    
    if (!phiDetails.PAddress) {
      newValidationMessages.PAddress = t("addressrequired"); 
      isValid = false;
    }

    // If not valid, update state and return
    if (!isValid) {
      setValidationMessages(newValidationMessages);
      return;
    }

    const atLeastOneSelected = toggleStates.Benefits || toggleStates.Claims || 
                             toggleStates.CaseManagement || toggleStates.Other;
  
  if (!atLeastOneSelected) {
    toast.error(t("selectatleastoneoption"));
    return;
  }
  if (!readAndUnderstand) {
    console.log("Attempting to show toast");
toast.error(t("agreetermsandconditions"));
return;
  }
    setLoading(true);
    try {
      const payload = {
        _Params: JSON.stringify({
          PAddress: phiDetails.PAddress,
          Genetic: toggleStates.Genetic ? "T" : "F",
          EmailId: contract.userData.EmailID,
          BenefitsDetails: phiDetails.BenefitsDetails,
          HIVTest: toggleStates.HIVTest ? "T" : "F",
          Drug: toggleStates.Drug ? "T" : "F",
          ClaimsDetails: phiDetails.ClaimsDetails,
          Mentalillness: toggleStates.Mentalillness ? "T" : "F",
          Claims: toggleStates.Claims ? "T" : "F",
          CreatedDate: new Date().toLocaleDateString("en-US"),
          Other: phiDetails.Other,
          CaseManagement: toggleStates.CaseManagement ? "T" : "F",
          PName: phiDetails.PName,
          CaseManagementDetails: phiDetails.CaseManagementDetails,
          Benefits: toggleStates.Benefits ? "T" : "F",
          DeviceType:isHighmarkPortal ? "HighmarkPortal" : "PatientPortal"
        })
      };
       
      const response = await axios.post(Endpoints.SavePHIForm, payload, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${token}`
        }
      });
      if (response.data && response.data.Result == "1") {
        console.log(payload);
        toast.success(t("phisaved"));
        setTimeout(() => {
            navigate("/benefits-landingpage");
          }, 2000); // Redirects after 3 seconds
      } else {
        toast.error(t("failedtosavephi"));
      }
    } catch (error) {
      console.error("Error saving PHI:", error);
      toast.error(t("errorsavingphi"));
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>        
        <h2 className="loading-text">{t("loading")}</h2>
      </div>
    );
  }

  return (
    <>
      <ToastContainer />

      {isHighmarkPortal ? 
            <div className="col-md-6 mt-4 d-flex inner-page-heading-wrapper">
            <button className="win-back-btn" onClick={() => navigate(-1)}>
                <span>
                <i className="bi bi-chevron-left"></i>
                </span>
            </button>       
            <h2 className="page-heading">{t('phiform')}</h2>
            </div>:
            <div className="col-md-6 mt-4 d-flex inner-page-heading-wrapper">
            <button className="win-back-btn" onClick={() => navigate(-1)}>
                <span>
                <i className="bi bi-chevron-left"></i>    
                {t('Back')}        
                </span>
            </button>       
            <h2 className="page-heading">{t('phiform')}</h2>
            </div>
          }

      {/* <div className="col-12 mt-4 inner-page-heading-wrapper">
        <button className="win-back-btn me-3" onClick={() => navigate(-1)}>
          <span>
            <i className="bi bi-chevron-left"></i> {t("back")}
          </span>
        </button>
        <h1 className="page-heading">{t("phiform")}</h1>
      </div> */}
      {phiDetails ? (
        <>
          <div className="col-12 col-md-12">
            <h4 className="page-heading-bold-primary-20">{t("authrization")}</h4>
            <p>{t("iauthorize")}</p>
            <div className="row">
              <div className="col-xl-6 mb-4 row pe-0 pe-md-5">
                <label className="col-sm-4 model-form-label mt-2">{t("membername")}</label>
                <div className="col-sm-6 pe-0 pe-md-5">
                  <input
                    type="text"
                    className="form-control win-form-control mobile-view"
                    value={`${(phiDetails.FirstName || "")
                      .charAt(0).toUpperCase() + (phiDetails.FirstName || "")
                      .slice(1).toLowerCase()} ${(phiDetails.LastName || "")
                      .charAt(0).toUpperCase() + (phiDetails.LastName || "")
                      .slice(1).toLowerCase()}`}                    readOnly
                  />
                </div>
              </div>
              <div className="col-xl-6 mb-4 row pe-0 pe-md-5">
                <label className="col-sm-4 model-form-label mt-2">{t("memberid")}</label>
                <div className="col-sm-6 pe-0 pe-md-5">
                  <input
                    type="text"
                    className="form-control win-form-control mobile-view"
                    value={phiDetails.MemberID || ""}
                    readOnly
                  />
                </div>
              </div>
              <div className="col-xl-6 mb-4 row pe-0 pe-md-5">
                <label className="col-sm-4 model-form-label mt-2">{t("telephone")}</label>
                <div className="col-sm-6 pe-0 pe-md-5">
                  <input
                    type="text"
                    className="form-control win-form-control mobile-view"
                    value={phiDetails.PhoneNumber || ""}
                    readOnly
                  />
                </div>
              </div>
              <div className="col-xl-6 mb-4 row pe-0 pe-md-5">
                <label className="col-sm-4 model-form-label mt-2">{t("address")}:</label>
                <div className="col-sm-6 pe-0 pe-md-5">
                  <input
                    type="text"
                    className="form-control win-form-control mobile-view"
                    value={phiDetails.Address || ""}
                    readOnly
                  />
                </div>
              </div>
            </div>
            <h4 className="page-heading-bold-primary-20 mt-5">{t("informationreleased")}</h4>
            <p>{t("phiformtext")} {t("phiformattext2")}</p>

            <div className="row">
               {[
               { label: t("benefitselegibility"), field: "Benefits", valueField: "BenefitsDetails" },
               { label: t("casemanagement"), field: "CaseManagement", valueField: "CaseManagementDetails" },
               { label: t("claims"), field: "Claims", valueField: "ClaimsDetails" },
               { label: t("other"), field: "Other", valueField: "Other" }
               ].map((item, index) => (
               
                     <div className="col-xl-6">
                        <div className="mb-3 row switch-control-wrapper" key={index}>
                           <label className="col-sm-4 model-form-label mt-2">
                              <label className="switch">
                              <input
                                 type="checkbox"
                                 className="switch-input"
                                 checked={toggleStates[item.field]}
                                 onChange={() => handleToggleChange(item.field)}
                              />
                              <span className="slider round"></span>
                              </label>
                              <span className="switch-label">{item.label}</span>
                           </label>
                           <div className="col-sm-6">
                              {toggleStates[item.field] && (
                              <input
                                 type="text"
                                 className="form-control win-form-control mobile-view"
                                 value={phiDetails[item.valueField] || ""}
                                 onChange={(e) => handleInputChange(item.valueField, e.target.value)}
                              />
                              )}
                           </div>
                        </div>
                     </div>
                  
               ))}
            </div>
            <p className="mt-5 mb-4">{t("phiformattext3")}</p>
            
            <div className="row">
               {[
               { label: t("phinotification"), field: "HIVTest" },
               { label: t("diagnosis"), field: "Drug" },
               { label: t("diagnosisillness"), field: "Mentalillness" },
               { label: t("genetic"), field: "Genetic" }
               ].map((item, index) => (
                  <div className="col-xl-6">
                     <div className="mb-4 switch-control-wrapper" key={index}>
                        <label className="switch">
                           <input
                           type="checkbox"
                           className="switch-input"
                           checked={toggleStates[item.field]}
                           onChange={() => handleToggleChange(item.field)}
                           />
                           <span className="slider round"></span>
                        </label>
                        <span className="switch-label">{item.label}</span>
                     </div>
                  </div>
               ))}
            </div>
          
            <h4 className="page-heading-bold-primary-20 mt-5">{t("personauthorized")}</h4>
            
            <div className="mt-4 mb-3 row">            
               <div className="col-xl-6">
                  <div className="mb-3 row">
                     <label className="col-sm-4 model-form-labell mandatory mt-2">{t("name1")}</label>
                     <div className="col-sm-6">
                        <input
                           type="text"
                           className="form-control win-form-control mobile-view"
                           value={phiDetails.PName || ""}
                           onChange={(e) => handleInputChange("PName", e.target.value)}
                        />
                        {validationMessages.PName && (
                           <div className="text-danger">{validationMessages.PName}</div>
                           )}
                     </div>
                  </div>
               </div>

               <div className="col-xl-6">
                  <div className="mb-3 row">
                     <label className="col-sm-4 model-form-labell mandatory mt-2">{t("address")}:</label>
                     <div className="col-sm-6">
                        <input
                           type="text"
                           className="form-control win-form-control mobile-view"
                           value={phiDetails.PAddress || ""}
                           onChange={(e) => handleInputChange("PAddress", e.target.value)}
                        />
                        {validationMessages.PAddress && (
                                       <div className="text-danger">{validationMessages.PAddress}</div>
                                       )}
                     </div>
                  </div>
               </div>

               
              
            </div>
            
            <p>
              <b>{t("plesenote")}</b>
            </p>
            <p>
              <ul>
                <li>{t("termstext")}</li>
                <li>{t("termstext1")}</li>
                <li>{t("termstext2")}</li>
                <li>{t("termstext3")}</li>
                <li>{t("termstext4")}</li>
              </ul>
            </p>
            <div className="mb-3 switch-control-wrapper">
              <label className="switch">
                <input
                  type="checkbox"
                  className="switch-input"
                  checked={readAndUnderstand}
                  onChange={handleReadAndUnderstandToggle}
                />
                <span className="slider round"></span>
              </label>
              <span className="switch-label">{t("readandundestand")}</span>
            </div>
            <div className="mb-3 row">
              <div className="col-12 d-flex">
                <button
                  className="win-btn-primary mobile-view mx-auto"
                  onClick={handleSubmit}
                 // disabled={!readAndUnderstand}
                >
                  {t("submit")}
                </button>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="loading-container">
        <div className="loading"></div>        
        <h2 className="loading-text">{t("loading")}</h2>
      </div>      )}
    </>
  );
};

export default Benefits_PHIForm;